export const setFocusById = (idSelector: string): void => {
  setTimeout(() => {
    document.getElementById(idSelector)?.focus();
  }, 1000);
};
